import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useUsersStore} from "../../store/users.store";

export const useUsers = () => {
    const setUsers = useUsersStore((state) => state.setUsers);

    return useMutation(PartnerApi.users, {
        onSuccess: (data) => {
            setUsers(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};